import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 16l3 -13l3 13z","key":"svg-0"}],["path",{"d":"M12 16v3c0 2.667 4 2.667 4 0","key":"svg-1"}]]

const IconUmbrellaClosed = createReactComponent('outline', 'umbrella-closed', 'UmbrellaClosed', __iconNode);

export default IconUmbrellaClosed;